// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3HhPx","dragIcon":"Choice_dragIcon__3V0PR","left":"Choice_left__3v3u6","input":"Choice_input__2vA6B"};